import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=fbf67cc4&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf67cc4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fbf67cc4')) {
      api.createRecord('fbf67cc4', component.options)
    } else {
      api.reload('fbf67cc4', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=fbf67cc4&scoped=true&", function () {
      api.rerender('fbf67cc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-29hNpCbkBS5Ud/JS/comp/Voucher-Unit.vue"
export default component.exports